// © Microsoft Corporation. All rights reserved.

/**
 * lower-case of 'ocid'
 */
export const QUERY_KEY_OCID = "ocid";
const WINDOWS_HEADER_PREFIX  = "win";

export function isWindowsScenario(currentUrl: URL | string): boolean {
    if (typeof currentUrl === "string") {
        try {
            currentUrl = new URL(currentUrl);
        } catch (e) {
            return false;
        }
    }

    if (!currentUrl) {
        return false;
    }

    let isMatch = false;

    if (currentUrl) {
        currentUrl.searchParams.forEach(function (value, key) {
            if (!isMatch && key.toLowerCase() === QUERY_KEY_OCID &&
                !!value && value.toLowerCase().substr(0, 3) === WINDOWS_HEADER_PREFIX) {
                isMatch = true;
            }
        });
    }

    return isMatch;
}
